module.exports = __webpack_public_path__ + "img/share_log.8a41c3e6.svg";